import { render, staticRenderFns } from "./GroupList.vue?vue&type=template&id=5f68fb76&"
import script from "./GroupList.vue?vue&type=script&lang=js&"
export * from "./GroupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/m1292/Documents/develop/laravel/cure-naruhodoga/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f68fb76')) {
      api.createRecord('5f68fb76', component.options)
    } else {
      api.reload('5f68fb76', component.options)
    }
    module.hot.accept("./GroupList.vue?vue&type=template&id=5f68fb76&", function () {
      api.rerender('5f68fb76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/designed/admin/GroupList.vue"
export default component.exports